import React from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';


const CmsElementCommerceProduct = (props) => {
  const {
    editMode,
    index,
    showElementSettings,
  } = props;

  // CMS Logic via Hook
  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getParamValue,
    getBackgroundStyle,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
    responsiveClasses
  } = useAbstractCmsElement(props);

  // dnd-kit Sortable Hook
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: index,
    disabled: !editMode
  });

  // Drag & Drop Styles
  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative',
    width: '100%',
    cursor: editMode ? 'move' : 'default'
  };

  // Logic & Class Construction
  const isVisible = editMode || shown;
  const shownClass = isVisible ? 'elem-shown' : 'elem-hidden';
  const textClass = `text-${getParamValue('mainColor', 'master')}`;

  const parallaxData = getParallaxData();

  const innerContent = (
    <div
      id={getMainId()}
      className={`ms-ecommerce-product-content ${shownClass} ${textClass} ${cssClasses} ${responsiveClasses}`.trim()}
      onClick={(e) => editMode && showElementSettings(e, index)}
      style={getBackgroundStyle()}
    >
      {elementStyleTag}

      {/* Main Content Area (Placeholder for product logic/styles) */}
      <div className="ms-ecommerce-product-inner">
        {/* Product-specific markup could go here later */}
      </div>

      {getAppendHtml()}
    </div>
  );

  return (
    <div
      ref={setNodeRef}
      style={dndStyle}
      {...attributes}
      {...listeners}
    >
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>

      </div>
    </div>
  );
};

export default CmsElementCommerceProduct;
